import { resourceExplorerViewDataByIdSelector } from "../resource-explorer-by-id/resourceExplorerViewDataByIdSelector";
import { RootState } from "../../../store";
import { resourceExplorerIdSelector } from "../current-resource-explorer/resourceExplorerIdSelector";
import { Budget } from "../../../../services/cloudchipr.api";

export const resourceExplorerViewBudgetsSelector = (
  state: RootState,
): Budget[] | null | undefined => {
  const viewId = resourceExplorerIdSelector(state);
  const view = resourceExplorerViewDataByIdSelector(state, viewId);

  return view?.budgets;
};
